export default [
  /** 实名认证 开始 */
  {
    path: '/authentication/authenticationForm',
    name: 'AuthenticationForm',
    component: () =>
      import(/* webpackChunkName: "coCreationResult" */ '../../views/authentication/AuthenticationForm.vue'),
    meta: {
      title: '实名认证',
    },
  },
  {
    path: '/authentication/vehicleUnbound',
    name: 'vehicleUnbound',
    component: () => import(/* webpackChunkName: "coCreationResult" */ '../../views/authentication/vehicleUnbound.vue'),
    meta: {
      title: '车辆解绑',
    },
  },
  {
    path: '/authentication/realnameauthenticationDetails',
    name: 'authenticationDetails',
    component: () =>
      import(/* webpackChunkName: "coCreationResult" */ '../../views/authentication/realnameauthenticationDetails.vue'),
    meta: {
      title: '实名认证',
    },
  },
  {
    path: '/authentication/identifyStatus',
    name: 'IdentifyStatus',
    component: () => import(/* webpackChunkName: "coCreationResult" */ '../../views/authentication/IdentifyStatus.vue'),
    meta: {
      title: '',
    },
  },
  /** 实名认证 结束 */
]
